<div class="l-main" role="main">
	<div class="l-container">

		<div class="l-content">


			<div class="panel-pane bg-transparent align-center">
				<ul class="list--pipe">
					<li><a href="">Visit the UC Davis directory</a></li>
				</ul>
			</div>
     <div class="panel-pane box">
       <!-- <div class="panel-pane box">-->
          
<!-- ********** Main content ********** -->

						<div id="main_section" role="main">

							<!-- Center column (primary content) -->

							<div id="center_column">

								<div id="center_column_inner_wrap">

					

								<!--	<form action="DeptListingSearchResults.htm" method="get"

										id="search_department_form">

										<div id="search_form">

											<label for="search_text">Search:</label> <input type="text"

												id="search_text" class="inputfield" name="filter" size="25"

												maxlength="255" value="" /> <input type="submit" name="sa"

												value="GO" class="inputsubmit" />

										</div>

									</form>
-->
									

									<p>To search by department, enter the department's full or

										partial name. The search will return all departments or

										cross-references (&quot;See&quot; also) that match or contain

										the department name you enter. You may use the wildcard

										&quot;*&quot; to match any part of the name. To find Human

										Resources, you could enter &quot;human resources&quot;,

										&quot;h* resources&quot;, &quot;human *&quot; or

										&quot;resources&quot;. The more specific your search, the

										fewer results are returned.</p>

									<p>When searching by phone number, you may enter the

										department's full (530-123-4567) or partial phone number

										(123-4567 or 3-4567).</p>

									<h2 id="dir_changes">Changing Department Directory

										Information</h2>

									<p>Follow the instructions below to update department

										directory information.</p>

									<ol>

										<li>In the <strong>Search</strong> field above, enter the

											name of the department whose information you want to change.

										</li>

										<li>Click <strong>Go</strong>.

										</li>

										<li>Click on the <strong>Update this listing</strong>

											link (next to the department's name).

										</li>

										<li>Log in using your login ID and Kerberos passphrase.</li>

										<li>A list of department approvers will be displayed.</li>

										<li>Contact a department approver to make updates to the

											department listing.</li>

									</ol>

									<p>Changes submitted will be posted once they have been

										reviewed for accuracy and/or approved.</p>

									<!-- This item is required so the columns appear to be of equal length. -->
									
									<div class="clearer">&nbsp;</div>



								</div>

							</div>

							<!-- End center column -->

						</div>

						<!-- ********** End main content ********** -->
						</div>
			</div>
		<!--end .l-content-->

	</div>

</div>
<!--End role=main-->
<p class="privacy">
	<strong>Privacy Notice:</strong> This campus directory is the property
	of <a href="https://www.ucdavis.edu"><font size="3" color="navy">University
			of California, Davis.</font> </a> To protect the privacy of individuals listed
	herein, in accordance with the State of California Information
	Practices Act, this directory may not be used, rented, distributed, or
	sold for commercial purposes.
</p>